// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   firebase: {
//     apiKey: "AIzaSyANHZNby2kf0f873I3dM6bYCvDjEGsSUFM",
//     authDomain: "appie-lab.firebaseapp.com",
//     projectId: "appie-lab",
//     storageBucket: "appie-lab.appspot.com",
//     messagingSenderId: "765390572153",
//     appId: "1:765390572153:web:277b6ce71f1e058ab322a8",
//     measurementId: "G-2CLNVZ1PSW"
//   }
// };
export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBavSxp-kX3guTh-FoLwzb_-u0w25jtvcI",
    authDomain: "appie-60ade.firebaseapp.com",
    databaseURL: "https://appie-60ade.firebaseio.com",
    projectId: "appie-60ade",
    storageBucket: "appie-60ade.appspot.com",
    messagingSenderId: "429601363438",
    appId: "1:429601363438:web:f982860f9f5d6868"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
